import { useState } from "react";
import { List, Card, Typography, Space } from "antd";
import { BarChartOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { formatDateTime } from "../../utils/formatDateTime";
import "./AnketaListKorisnik.css";
import "../Dokument/DokumentCardsKorisnik.css";

const { Text } = Typography;

function AnketaCardsKorisnik({ ankete }) {
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentAnkete = ankete.slice(indexOfFirst, indexOfLast);

  const totalPages = Math.ceil(ankete.length / itemsPerPage);

  const handleClickAnketa = async (anketaId) => {
    navigate(`/ankete/${anketaId}`);
  };

  return (
    <List
      grid={{ gutter: 16, xs: 1, sm: 1, md: 3, lg: 4, xl: 4, xxl: 4 }}
      dataSource={currentAnkete}
      locale={{ emptyText: "Nema dostupnih anketa." }}
      style={{ marginTop: "10px", marginBottom: "0px" }}
      renderItem={(anketa, index) => {
        const colors = ["#c9bc8d", "#f7eba8", "#babd7d", "#ded6a0"];
        const backgroundColor = colors[index % colors.length];

        return (
          <List.Item
            onClick={() => handleClickAnketa(anketa.id, anketa.saglasnostId)}
          >
            <div className="document-cards">
              <Card
                hoverable
                cover={
                  <div
                    className="dokument-card-cover"
                    style={{ backgroundColor }}
                  >
                    <BarChartOutlined
                      style={{ fontSize: 48, color: "#2b494b" }}
                    />
                  </div>
                }
              >
                <div className="dokument-card-title">{anketa.naziv}</div>
                <Space className="dokument-card-footer" align="center" size={4}>
                  <Text type="secondary">
                    Važi do: {formatDateTime(anketa.datumVazenja)}
                  </Text>
                </Space>
              </Card>
            </div>
          </List.Item>
        );
      }}
    >
      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            Prethodna
          </button>

          <span>
            Stranica {currentPage} od {totalPages}
          </span>

          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            Sljedeća
          </button>
        </div>
      )}
    </List>
  );
}

export default AnketaCardsKorisnik;
